import usePluginEntities from "hooks/usePluginEntities";
const usePluggableEntityShareFormGroup = () => {
  var _a, _b;
  const pluggableCollection = usePluginEntities("components.collection");
  return (_b = (_a = pluggableCollection == null ? void 0 : pluggableCollection[0]) == null ? void 0 : _a.AddCollectionFormGroup) != null ? _b : null;
};
export default usePluggableEntityShareFormGroup;
